module.exports = __webpack_public_path__ + "img/user.2e514ec8.png";